import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import globalConfig from 'Helper/configHelpers'
import { useNavigate, Outlet } from 'react-router-dom'
import InactivityTimer from './InactivityTimer.jsx'
import { handleUserAlerts } from 'actions/authActions'
import AuthView from './AuthView.jsx'
import Waiting from './PanelComponents/Waiting.jsx'
import debug from 'Helper/debugHelpers'

const AuthRoute = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const inactivityTimeout = useSelector(state => state.auth.inactivity_timeout) || 10
  const alerts = useSelector(state => state.user.notification_metadata?.urgent_notifications)  || []
  const privilege = useSelector(state => state.auth.privilege)  || []
  const token = useSelector(state => state.auth.token)
  const userId = useSelector(state => state.auth.user_id)
  const modal = useSelector(state => state.modal)
  const pathname = useSelector(state => state.router.location.pathname)
  const isAuthorized = token != null && privilege != null && userId != null
  const authReady = useSelector(state => Array.isArray(state.appConfig.privileges)) // make sure privileges have been loaded
  const isLobbyPath = pathname.startsWith(globalConfig.basepath + 'lobby')
  const isLogoutPath = pathname === globalConfig.basepath + 'logout'

  useEffect(() => {
    if (isAuthorized && !isLobbyPath && !isLogoutPath && alerts.length > 0 && modal.length === 0) {
      dispatch(handleUserAlerts())
    }
    // note: modals in the list below is important even though its not used in the function because it needs
    // to trigger handleUesrAlerts to be called again.
  }, [alerts, isAuthorized, isLobbyPath, modal])

  useEffect(() => {
    if (!isAuthorized) {
      let debugString = 'token='
      debugString += token != null ? 'good' : 'bad'
      debugString += ' user='
      debugString += userId != null ? 'good' : 'bad'
      debugString += ' priv='
      debugString += privilege != null ? 'good' : 'bad'
      debug.log(
        `AuthRoute - not authorized directing to logout (${debugString})`,
        debug.logLevels.AUTH
      )
      navigate('/login')
    }
  }, [isAuthorized])

  if (!isLobbyPath && !isLogoutPath && isAuthorized && authReady) {
    // this is the bulk of summit when the user is logged in.

    return (
      <InactivityTimer
        inactivityTimerMins={inactivityTimeout}
        locationChange={url =>
          navigate(url)
        }
      >
        <Outlet />
      </InactivityTimer>
    )
  } else if (isAuthorized && authReady && !isLogoutPath) {
    // this is the lobby app
    return <Outlet />
  } else {
    return (
      <AuthView>
        <Waiting/>
      </AuthView>
    )
  }
}

export default AuthRoute
